import React from 'react';
import './styles.scss';
import { Button } from 'antd';
import useTheme from '@hooks/useTheme';
import ThemeImg from '@components/ThemeImg/ThemeImg';
import darkSrc from '@assets/imgs/Insight fill.png';
import lightSrc from '@assets/imgs/Insight.png';

function ThemeTestPage(props) {
  const { theme, changeTheme } = useTheme();
  return (
    <div className="test-theme">
      <Button type="primary" onClick={() => changeTheme('dark')}>
        Change theme to dark
      </Button>
      <br />
      <Button type="primary" onClick={() => changeTheme('light')}>
        Change theme to light
      </Button>

      <div
        style={{ height: '3.125rem', border: '1px solid var(--text-color)' }}
      >
        Current theme is {theme}
      </div>

      <ThemeImg darkSrc={darkSrc} lightSrc={lightSrc} />

      <div className="bg" />
    </div>
  );
}

export default ThemeTestPage;
